// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__vhZSw","toast_success":"Toast_toast_success__1RSET","toast_error":"Toast_toast_error__3WOVT"};